import { useGetEnums } from 'api-hooks/common/query';
import Input from 'components/elements/field';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  name: string;
  required?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
}

export default function GenderSelectInput(props: Props) {
  const { data } = useGetEnums(
    { class: 'gender-type' },
    { staleTime: Infinity },
  );
  const { t } = useTranslation();
  const {
    name,
    disabled,
    label = t('common:gender'),
    placeholder = t('common:select_gender'),
    required,
  } = props;
  const options = React.useMemo(() => {
    if (data) {
      return data.data.map((item) => ({
        label: t(`common:${item.value}`),
        value: item.value,
      }));
    }
    return [];
  }, [data, t]);

  return (
    <Input
      type="select"
      name={name}
      disabled={disabled}
      label={label}
      placeholder={placeholder}
      required={required}
      options={options}
    />
  );
}
